// PreviousOrders.js
import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Button,
    Paper,
    List,
    ListItem,
    ListItemText,
    Chip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { auth, db } from './firebaseConfig';

const PreviousOrders = () => {
    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrders = async () => {
            if (!auth.currentUser) return;

            const q = query(
                collection(db, 'orders'),
                where('valetId', '==', auth.currentUser.uid),
                where('status', '==', 'completed'),
                orderBy('completedAt', 'desc')
            );

            try {
                const snapshot = await getDocs(q);
                const ordersList = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setOrders(ordersList);
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        };

        fetchOrders();
    }, []);

    return (
        <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
            <Typography variant='h5' gutterBottom>
                Previous Orders
            </Typography>

            <List>
                {orders.map((order) => (
                    <Paper key={order.id} sx={{ mb: 2 }}>
                        <ListItem>
                            <ListItemText
                                primary={`Order #${order.id}`}
                                secondary={
                                    <>
                                        <Typography
                                            component='span'
                                            display='block'>
                                            Customer: {order.customerName}
                                        </Typography>
                                        <Typography
                                            component='span'
                                            display='block'>
                                            Date:{' '}
                                            {new Date(
                                                order.completedAt?.toDate()
                                            ).toLocaleDateString()}
                                        </Typography>
                                        <Typography
                                            component='span'
                                            display='block'>
                                            Location:{' '}
                                            {order.location?.description}
                                        </Typography>
                                    </>
                                }
                            />
                            <Chip
                                label='Completed'
                                color='success'
                                size='small'
                            />
                        </ListItem>
                    </Paper>
                ))}
            </List>

            {orders.length === 0 && (
                <Typography color='textSecondary' align='center'>
                    No previous orders found
                </Typography>
            )}

            <Button
                variant='outlined'
                fullWidth
                onClick={() => navigate('/home')}
                sx={{ mt: 2 }}>
                Back to Home
            </Button>
        </Box>
    );
};

export default PreviousOrders;
